module.exports = __webpack_public_path__ + "img/fragment_300.cdfc716c.png";